import { useContext } from "react";

import FlagIcon from "@/assets/icons/flag.svg";
import NoIcon from "@/assets/icons/no-symbol.svg";
import TrashIcon from "@/assets/icons/trash.svg";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "@components/Dropdown";
import TextButton from "@components/TextButton";

import MentionCardContext from "../../../context";

type RemoveMentionProps = {
  currentId?: string;
};

const RemoveMention: React.FunctionComponent<RemoveMentionProps> = ({
  currentId,
}) => {
  const { removeAll, removeSource, removeIndividual, mentions } =
    useContext(MentionCardContext);
  const MoreThanOne = mentions.length > 1;

  return (
    <Dropdown>
      <DropdownToggle>
        <TextButton icon={TrashIcon} data-testid="toggle-remove-mention">
          {L.MENTIONS_REMOVE_MENTION}
        </TextButton>
      </DropdownToggle>
      <DropdownMenu>
        {currentId ? (
          <DropdownItem
            onClick={() => removeIndividual(currentId)}
            data-testid="remove-mention-individual"
          >
            <TrashIcon /> {L.MENTIONS_NOT_INTERESTING}
          </DropdownItem>
        ) : null}
        <>
          {MoreThanOne || !currentId ? (
            <DropdownItem onClick={removeAll} data-testid="remove-mention-all">
              <NoIcon /> {L.MENTIONS_REMOVE_ALL_MENTIONS}
            </DropdownItem>
          ) : null}
        </>
        <DropdownItem
          onClick={removeSource}
          data-testid="remove-mention-source"
        >
          <FlagIcon /> {L.MENTIONS_REMOVE_SOURCE}
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default RemoveMention;
